import type * as Scrivito from "scrivito";

type Props = {
  value: string;
  view: string;
  obj: Scrivito.Link;
};

export const getURLForSelectCountry = ({ value, view, obj }: Props) => {
  switch (true) {
    case value === "uk" && view === "forgotPass":
      return "https://www.troxuk.co.uk/mytrox/account/new_password";
    case value === "uk" && view === "newAccount":
      return "https://www.troxuk.co.uk/mytrox/account/new";
    case value === "ch" && view === "forgotPass":
      return "https://www.troxhesco.ch/mytrox/account/new_password";
    case value === "ch" && view === "newAccount":
      return "https://www.troxhesco.ch/mytrox/account/new";
    case value !== null:
      return obj
        ?.url()
        ?.replace(/^(https?:\/\/[^/]+?)\.de(?=\/|$)/, `$1.${value}`);
    default:
      return "";
  }
};
